export default {
  authorityGroupsResults: [],
};
